import type { KnowledgeScope } from "@yazamco/shared-types";

export type MicrosoftProduct = "microsoft365" | "sharepoint" | "onedrive" | "outlook" | "teams";

const PRODUCT_ASSETS: Record<MicrosoftProduct, string> = {
  microsoft365: "/assets/microsoft-365-2025/microsoft365.svg",
  sharepoint: "/assets/microsoft-365-2025/sharepoint.svg",
  onedrive: "/assets/microsoft-365-2025/onedrive.svg",
  outlook: "/assets/microsoft-365-2025/outlook.svg",
  teams: "/assets/microsoft-365-2025/teams.svg",
};

/** The Microsoft service represented by a knowledge scope. */
export function productForKnowledgeScope(scope: KnowledgeScope): MicrosoftProduct | null {
  switch (scope.kind) {
    case "all":
      return "microsoft365";
    case "sharePoint":
    case "sharePointSite":
    case "sharePointPath":
      return "sharepoint";
    case "oneDrive":
    case "oneDrivePath":
      return "onedrive";
    case "mail":
      return "outlook";
    case "teams":
      return "teams";
    case "externalItem":
    default:
      return null;
  }
}

/** Official current Microsoft product artwork, kept local so the picker works offline. */
export function MicrosoftProductMark({
  product,
  size = 18,
}: {
  product: MicrosoftProduct;
  size?: number;
}): JSX.Element {
  return (
    <span
      aria-hidden
      className={`cp-product-mark cp-product-mark-${product}`}
      style={{ width: size, height: size, flexBasis: size }}
    >
      <img src={PRODUCT_ASSETS[product]} alt="" draggable={false} />
    </span>
  );
}
